function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import { range } from '@finect/front-utils/range';
import { withLeadingChar } from '@finect/front-utils/withLeadingChar';
import { longMonths } from '../../../../commons/locales/es_ES';
import { Chip } from '../../../../Chip';
import { FormControl, DateBlock, ShortcutBlock } from './partials';
import { isNull } from './utils';
var getMinYear = function getMinYear(minDate) {
  if (!minDate) {
    return new Date().getFullYear();
  }
  return new Date(minDate).getFullYear();
};
var getMaxYear = function getMaxYear(maxDate, min) {
  if (!maxDate) {
    var minYear = getMinYear(min);
    return minYear + 10;
  }
  return new Date(maxDate).getFullYear();
};
export var getValueFromState = function getValueFromState(state) {
  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var day = state.day,
    month = state.month,
    year = state.year,
    hour = state.hour,
    minute = state.minute;
  if (isNull(day) || isNull(month) || isNull(year)) {
    return null;
  }
  return "".concat(year || '', "-").concat(withLeadingChar(month, 2, '0'), "-").concat(withLeadingChar(day, 2, '0')).concat(withTime ? "T".concat(withLeadingChar(hour, 2, '0'), ":").concat(withLeadingChar(minute, 2, '0'), ":00.000Z") : '');
};
export var getStateFromProps = function getStateFromProps(props) {
  var _ref = props.value ? props.value.split('T') : [],
    _ref2 = _slicedToArray(_ref, 2),
    date = _ref2[0],
    time = _ref2[1];
  if (date) {
    var _date$split = date.split('-'),
      _date$split2 = _slicedToArray(_date$split, 3),
      year = _date$split2[0],
      month = _date$split2[1],
      day = _date$split2[2];
    if (time) {
      var _time$split = time.split(':'),
        _time$split2 = _slicedToArray(_time$split, 2),
        hour = _time$split2[0],
        minute = _time$split2[1];
      return {
        year: Number(year),
        month: Number(month),
        day: Number(day),
        hour: Number(hour),
        minute: Number(minute)
      };
    }
    return {
      year: Number(year),
      month: Number(month),
      day: Number(day),
      hour: null,
      minute: null
    };
  }
  return {};
};
var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);
  var _super = _createSuper(DatePicker);
  function DatePicker() {
    var _this;
    _classCallCheck(this, DatePicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({
      year: null,
      month: null,
      day: null,
      hour: null,
      minute: null,
      shortcut: null
    }, getStateFromProps(_this.props)));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      _this.props.onChange && _this.props.onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "checkMinDateTime", function (date) {
      var minDateTime = _this.props.minDateTime;
      if (!minDateTime) {
        return true;
      }
      return date && new Date(date) >= new Date(minDateTime);
    });
    _defineProperty(_assertThisInitialized(_this), "handleParamChange", function (field, value) {
      var newState = _objectSpread(_objectSpread({}, _this.state), {}, _defineProperty({}, field, value));
      var newDate = getValueFromState(newState, _this.props.withTime);
      if (_this.checkMinDateTime(newDate)) {
        _this.setState(_defineProperty({}, field, Number(value)), function () {
          _this.handleChange(newDate);
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleDayChange", function (event) {
      return _this.handleParamChange('day', event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMonthChange", function (event) {
      return _this.handleParamChange('month', event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleYearChange", function (event) {
      return _this.handleParamChange('year', event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleHourChange", function (event) {
      return _this.handleParamChange('hour', event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMinuteChange", function (event) {
      return _this.handleParamChange('minute', event.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleShortcut", function (shortcut) {
      _this.setState({
        shortcut: shortcut.date
      }, function () {
        _this.handleChange(shortcut.date);
      });
    });
    return _this;
  }
  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$withTime = this.props.withTime,
        withTime = _this$props$withTime === void 0 ? false : _this$props$withTime;
      var _this$props$field$pro = this.props.field.properties,
        properties = _this$props$field$pro === void 0 ? {} : _this$props$field$pro;
      var _ref3 = properties || {},
        _ref3$shortcuts = _ref3.shortcuts,
        shortcuts = _ref3$shortcuts === void 0 ? [] : _ref3$shortcuts,
        _ref3$min = _ref3.min,
        min = _ref3$min === void 0 ? null : _ref3$min,
        _ref3$max = _ref3.max,
        max = _ref3$max === void 0 ? null : _ref3$max;
      var _this$state = this.state,
        year = _this$state.year,
        month = _this$state.month,
        day = _this$state.day,
        hour = _this$state.hour,
        minute = _this$state.minute;
      var yearMonthDay = getValueFromState(this.state, false);
      var fromYear = getMinYear(min);
      var toYear = getMaxYear(max, min);
      var fromDay = 1;
      var toDay = 31;
      return React.createElement("div", null, React.createElement(FormControl, null, React.createElement(DateBlock, {
        size: "medium",
        isLeft: true
      }, React.createElement("select", {
        onChange: this.handleDayChange,
        value: day
      }, React.createElement("option", {
        value: "null"
      }, "D\xEDa"), range(toDay - fromDay + 1, fromDay).map(function (itDay) {
        return React.createElement("option", {
          key: itDay,
          value: itDay
        }, itDay);
      }))), React.createElement(DateBlock, {
        size: "medium"
      }, React.createElement("select", {
        onChange: this.handleMonthChange,
        value: month
      }, React.createElement("option", {
        value: "null"
      }, "Mes"), longMonths.map(function (monthName, key) {
        return React.createElement("option", {
          key: key,
          value: key + 1
        }, monthName);
      }))), React.createElement(DateBlock, {
        size: "medium",
        isRight: true
      }, React.createElement("select", {
        onChange: this.handleYearChange,
        value: year
      }, React.createElement("option", {
        value: "null"
      }, "A\xF1o"), range(toYear - fromYear + 1, fromYear).map(function (itYear) {
        return React.createElement("option", {
          key: itYear,
          value: itYear
        }, itYear);
      }))), withTime && React.createElement(DateBlock, {
        size: "medium",
        isLeft: true,
        marginLeft: true
      }, React.createElement("select", {
        onChange: this.handleHourChange,
        value: hour
      }, React.createElement("option", {
        value: "null"
      }, "Hora"), range(24, 0).map(function (itHour) {
        return React.createElement("option", {
          key: itHour,
          value: itHour
        }, itHour, " h");
      }))), withTime && React.createElement(DateBlock, {
        size: "medium",
        isRight: true
      }, React.createElement("select", {
        onChange: this.handleMinuteChange,
        value: minute
      }, React.createElement("option", {
        value: "null"
      }, "Minuto"), range(60, 0).map(function (itMinute) {
        return React.createElement("option", {
          key: itMinute,
          value: itMinute
        }, itMinute, " m");
      })))), shortcuts.length ? React.createElement(ShortcutBlock, null, shortcuts.map(function (shortcut, key) {
        return React.createElement(Chip, {
          size: "medium",
          key: key,
          withIcon: false,
          value: shortcut.name,
          onAction: function onAction() {
            _this2.handleShortcut(shortcut);
          },
          isActive: shortcut.date.includes(yearMonthDay || '')
        });
      })) : null);
    }
  }]);
  return DatePicker;
}(React.Component);
export default DatePicker;